<template>
  <div class="scroll-board w-100">
    <div class="scroll-wrapper px-2 " :style="{ transform: `translateY(-${currentIndex * itemHeight}px)`, transition: transitionStyle }"
    >
      <!-- 遍历消息列表 -->
      <div
          @mouseenter="stopScrolling"
          @mouseleave="startScrolling"
          @click="goto(msg)"
          class="point-curser scroll-item  d-flex align-items-center justify-content-between pub-hover-primary"
          v-for="(msg, index) in messages" :key="index">
        <div class="showOne-row text-start "> {{ msg.Title }}</div>
        <div class="d-none d-md-block showTime text-end">{{msg.date}}</div>
      </div>
      <div class="point-curser scroll-item w-100 d-flex align-items-center justify-content-between" v-if="!messages || messages.length<0">
        <div class="pub-one-row-flex"> 暂无消息 </div>
      </div>
    </div>
  </div>
<!--  <div class="scroll-container">-->
<!--    <div class="message-wrapper w-100 px-4" >-->
<!--      <div v-for="(message, index) in messages" :key="index" class="w-100 message-item d-flex align-items-center justify-content-between">-->
<!--         <div> {{ message }}</div>-->
<!--        <div>2022-10-10</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script setup>
import { ref, onMounted,defineProps,onBeforeUnmount } from "vue";
import router from "@/router";
const pro = defineProps({
  messages:{
    default:[]
  },
  path:{
    default:"", ///noticeannouncementDetail,
  }
})

// 消息内容列表
// const messages = ref([
//   "消息 1：限时促销，立即抢购！",
//   "消息 2：新品上线，欢迎选购！",
//   "消息 3：满100减20，优惠多多！",
//   "消息 4：注册会员享特权！",
//   "消息 5：节日特惠，折扣不停！"
// ]);

// 滚动逻辑
const currentIndex = ref(0); // 当前滚动的索引
const itemHeight = 40; // 每条消息的高度（px）
const intervalTime = 2000; // 每次滚动的时间间隔（ms）
const transitionStyle = "transform 0.5s ease-in-out"; // CSS 动画过渡效果

let scrollInterval;

// 启动滚动
function startScrolling() {
  scrollInterval = setInterval(() => {
    currentIndex.value++;

    // 无缝滚动
    if (currentIndex.value >= pro.messages.length) {
      setTimeout(() => {
        // 清除动画并重置到顶部
        currentIndex.value = 0;
      }, 500); // 等待动画结束后重置
    }
  }, intervalTime);
}

// 停止滚动（用于鼠标悬停等场景）
function stopScrolling() {
  clearInterval(scrollInterval);
}

// 生命周期
onMounted(() => {
  startScrolling();
});
onBeforeUnmount(()=>{
  stopScrolling()
})
const goto = (item) => {
  router.push({path: pro.path,query:{id:item.ID}})
}
</script>

<style scoped>
/* 父容器 */
.scroll-board {
  width: 300px;
  height: 40px; /* 与单条消息高度一致 */
  overflow: hidden;
  /*border: 1px solid #ddd;*/
  border-radius: 5px;
  position: relative;
  /*background-color: #f9f9f9;*/
  /*box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);*/
}

/* 滚动内容容器 */
.scroll-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 每条消息样式 */
.scroll-item {
  height: 40px; /* 单条消息高度 */
  line-height: 40px; /* 垂直居中 */
  text-align: center;
  font-size: 16px;
  color: #333;
  background-color: transparent;
  width: 100%;
  overflow: hidden;
}
.showOne-row{
   /*width: calc(100% - 20rem);*/
  word-break: break-all;
  text-overflow: ellipsis;
  white-space:nowrap;
  overflow: hidden;
}
.showTime{
  /*width: 14rem;*/
  /*background: yellow;*/
}
</style>
